import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, message } from 'antd';
import { BookyInput } from '../Forms/BookyInput';
import { EditOutlined } from '@ant-design/icons';
import { TextService } from '../../Services/TextService';
import { WebApiCompanyDtoCompanyAdministratorResultDto, WebApiServicesDataTransferObjectsGroupServiceGroupResultDto } from '../../Repository/eventbookyapi';
import { GroupService } from '../../Services/GroupService';
import { BookyCheckbox } from '../Forms/BookyCheckbox';
import { GroupType } from '../../Types/GroupType';

export const EditGroup = (props: any) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const GetText = TextService.GetText;
    const [admins, setAdmins] = useState([] as WebApiCompanyDtoCompanyAdministratorResultDto);

    const onCancel = () => {
        setOpen(false);
    };

    useEffect(() => {
        form.setFieldValue("groupName", props.group.name);
        form.setFieldValue("isDefault", props.group.groupType == GroupType.Default ? true : false)
    }, [props]);

    const setFieldCustomError = (fieldName: string, error: string) => {
        form.setFields([
            {
                name: fieldName,
                errors: [error],
            },
        ]);
    };

    const onEdit = async (values: any) => {

        let foundError = false;

        props.groups.forEach((group: WebApiServicesDataTransferObjectsGroupServiceGroupResultDto) => {
            if (group.name == values.groupName && group.id != props.group.id) {
                setFieldCustomError("groupName", GetText("EditGroup_NameExist"));
                foundError = true;
            }

            if (values.isDefault && group.groupType == GroupType.Default && group.id != props.group.id) {
                message.warning(GetText("EditGroup_AlreadyExistStandardgroup"));
                foundError = true;
            }
        });

        if (foundError) {
            return;
        }
        try {
            await GroupService.EditGroup({
                id: props.group.id,
                groupName: values.groupName,
                groupType: values.isDefault == true ? GroupType.Default : GroupType.Unspecified,
            });
        } catch (error) {
            message.warning(GetText("EditGroup_Error"));
            return;
        }
        setOpen(false);

        props.loadGroups();
    };

    return (
        <>
            <Modal
                open={open}
                title={GetText("EditGroup_ModalTitle")}
                okText={GetText("EditMember_ModalOk")}
                cancelText={GetText("EditMember_ModalCancel")}
                onCancel={onCancel}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            onEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form form={form} labelAlign={"left"} labelCol={{ span: 8, offset: 0 }} wrapperCol={{ span: 16 }} onFinish={onEdit}>
                    <Col>
                        <BookyInput label={GetText("EditGroup_GroupName")} requiredMessage={GetText("CreateGroup_RequiredText")} name="groupName" />
                        <BookyCheckbox name="isDefault" alignLabelRight={true} label={"Standardgrupp (Nya medlemmar går med i denna grupp automatiskt)"} />
                    </Col>
                </Form>
            </Modal>

            <EditOutlined
                style={{ fontSize: "20px" }}
                type="primary"
                onClick={() => {
                    setOpen(true);
                }}
            >
            </EditOutlined>
        </>
    );
};
